export const IOS_APP_STORE_ID = "6743433333"
export const ANDROID_PACKAGE_NAME = "tech.matsuri.cleaning"

export const IOS_APP_STORE_URL = `https://apps.apple.com/us/app/m2m-cleaning/id${IOS_APP_STORE_ID}`
export const ANDROID_PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`
